import { defmulti } from "@thi.ng/defmulti";
import { Type } from "@thi.ng/geom-api";
import { classifyPointInCircle, classifyPointInTriangle2, } from "@thi.ng/geom-isec";
import { EPS, sign } from "@thi.ng/math";
import { dot } from "@thi.ng/vectors";
import { dispatch } from "../internal/dispatch";
export const classifyPoint = defmulti(dispatch);
classifyPoint.addAll({
    [Type.CIRCLE]: ($, p, eps = EPS) => classifyPointInCircle(p, $.pos, $.r, eps),
    [Type.PLANE]: ($, p, eps) => sign(dot($.normal, p) - $.w, eps),
    [Type.TRIANGLE]: ({ points }, p, eps = EPS) => classifyPointInTriangle2(p, points[0], points[1], points[2], eps),
});
classifyPoint.isa(Type.SPHERE, Type.CIRCLE);
